export const WORKSPACE_LINE_PLOT_SETTINGS_DESCRIPTION =
  'Apply settings to all line plots in this workspace.';

export const SECTION_LINE_PLOT_SETTINGS_DESCRIPTION =
  'Apply settings to all line plots in this section.';

export const WORKSPACE_RUN_DISPLAY_SETTINGS_DESCRIPTION =
  'Customize run display in this workspace.';

export const WORKSPACE_MEDIA_SETTINGS_DESCRIPTION =
  'Set global defaults for images, videos, audio and point clouds in this workspace.';

export const SECTION_MEDIA_SETTINGS_DESCRIPTION =
  'Set global defaults for images, videos, audio and point clouds in this section.';
